if (!customElements.get('cb-recently-viewed')) {
  customElements.define('cb-recently-viewed', class extends HTMLElement {
    async connectedCallback() {
      const current = this.dataset.handle;
      if (!current) return;
      const key = 'clothing-beyond-recent-products';
      let handles = [];
      try {
        const saved = JSON.parse(localStorage.getItem(key) || '[]');
        if (Array.isArray(saved)) handles = [...new Set(saved.filter(h => typeof h === 'string' && /^[a-z0-9-]+$/.test(h) && h !== current))].slice(0, 4);
        localStorage.setItem(key, JSON.stringify([current, ...handles]));
      } catch { return; }
      this.controller = new AbortController();
      const cards = await Promise.all(handles.map(async handle => {
        try {
          const root = this.dataset.root.endsWith('/') ? this.dataset.root : this.dataset.root + '/';
          const url = new URL(`${root}products/${encodeURIComponent(handle)}`, location.origin);
          url.searchParams.set('view', 'inspiration-universal');
          url.searchParams.set('section_id', this.dataset.section);
          const response = await fetch(url, { signal: this.controller.signal });
          if (!response.ok) return null;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          return html.querySelector('template[data-recent-card]')?.content.firstElementChild || null;
        } catch { return null; }
      }));
      if (!this.isConnected) return;
      const grid = this.querySelector('[data-recent-grid]');
      for (const card of cards.filter(Boolean)) {
        card.querySelectorAll('a[href]').forEach(a => { const url = new URL(a.href, location.origin); url.searchParams.set('view', 'inspiration-universal'); a.href = url.pathname + url.search; });
        grid.append(card);
      }
      this.hidden = !grid.children.length;
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
